import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import ViewDetails from './ViewDetails';
import errorBoundary from '@ifeng/errorBoundary';

const FormInfo = ({ understand, understandHandle }) => {
    const [confirmData, setConfirmData] = useState({
        isClickOk: understand,
        isCheck: false,
        isClosePopup: true,
    });
    const confirmDataHandle = (value) => {
        document.body.style.overflow = '';
        setConfirmData(value);

        understandHandle(value.isClickOk);
    };
    const viewDetailHandle = () => {
        document.body.style.overflow = '';
        setConfirmData({
            isClickOk: understand,
            isCheck: false,
            isClosePopup: false,
        });
    };

    return (
        <div className={styles.formInfo}>
            {/* <div className={styles.formInfoTitle}>我們會對你上傳的信息嚴格保密，請放心上傳。</div> */}
            <div
                className={styles.formInfoBox}>
                <div
                    className={`${styles.formInfoIcon} ${understand ? styles.active : ''}`}
                    onClick={() => {
                        understandHandle(!understand);
                    }}
                />
                <div className={styles.formInfoText}>
                    本人对以上报名信息及内容真实性负责，并知晓相关法律规定。点击
                    <span
                        onClick={() => {
                            viewDetailHandle(confirmData);
                        }}
                        className={styles.formDetail}>
                            查看详情
                    </span>
                </div>
            </div>
            <ViewDetails confirmData={confirmData} confirmDataHandle={confirmDataHandle} />
        </div>
    );
};

FormInfo.propTypes = {
    understand: PropTypes.bool,
    understandHandle: PropTypes.func,
};

export default errorBoundary(FormInfo);
